import { styled } from 'styled-components'

interface StyledRadioUiProps {
  $checked?: boolean
}

export const StyledRadioUi = styled.span<StyledRadioUiProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  border: 1.5px solid #6b7c93;
  transition: background, border 0.2s ease;

  &:hover {
    border: 5px solid #00a0ff;
  }

  ${props =>
    props.$checked &&
    `
      background: white;
      border: 5px solid #00a0ff;
  `}
`
